export const isGuid = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const isTwoCharacterAlphaNumericStrandAbbreviation = /^[A-Z0-9]{1,2}$/;

export const isOrderedListInputRule = /^(\d+|[a-z])\.\s$/;
